import React from 'react'
import PropTypes from 'prop-types'
import { Close } from '@material-ui/icons'
import { Typography, Button, Tooltip } from '@material-ui/core'

function ItemHeader({ title, tooltip = '', remove, children }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Tooltip title={tooltip}>
                <Typography variant={'h6'} color={'textPrimary'}>
                    {title}
                </Typography>
            </Tooltip>
            {children}
            <Button disableRipple={true} onClick={() => remove()}>
                <Close color="secondary" />
            </Button>
        </div>
    )
}

ItemHeader.propTypes = {
    title: PropTypes.string.isRequired,
    remove: PropTypes.func.isRequired
}

export default ItemHeader
